/**
 * Currency Updater Utility
 * 
 * This script helps update exchange rates for the CurrencyUtils.
 * You can call this periodically to keep rates up to date.
 */

window.CurrencyUpdater = {
  /**
   * Fetch current exchange rates from a free API
   * Note: This is a basic implementation. For production, consider using a paid API
   * or Shopify's built-in currency conversion features.
   */
  async fetchExchangeRates() {
    try {
      // Using a free API (you may want to replace this with a more reliable service)
      const response = await fetch('https://api.exchangerate-api.com/v4/latest/EUR');
      const data = await response.json();
      
      if (data && data.rates) {
        // Update the CurrencyUtils with new rates
        CurrencyUtils.updateExchangeRates(data.rates);
        console.log('Exchange rates updated successfully');
        return data.rates;
      }
    } catch (error) {
      console.warn('Failed to fetch exchange rates:', error);
      console.log('Using fallback rates from CurrencyUtils configuration');
    }
    
    return null;
  },

  /**
   * Update rates on page load (optional)
   */
  init() {
    // Update rates when the page loads
    this.fetchExchangeRates();
    
    // Optionally update rates every hour
    setInterval(() => {
      this.fetchExchangeRates();
    }, 60 * 60 * 1000); // 1 hour
  },

  /**
   * Manual rate update function
   */
  updateRates() {
    return this.fetchExchangeRates();
  }
};

// Auto-initialize if this script is loaded
if (typeof CurrencyUtils !== 'undefined') {
  CurrencyUpdater.init();
} 